<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="d-flex justify-center">
            <v-chip label>
              Niveles
            </v-chip>

          </v-card-title>
          <v-card-text>
            <niveles @getAllGradosMantenimiento="getGradosMant"></niveles>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="d-flex justify-center">
            <v-chip label>
              Grados
            </v-chip>
          </v-card-title>
          <v-card-text>
            <grados :GradosMantenimiento="GradosMant" @getAllGradosMantenimiento="getGradosMant"></grados>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import axios from "../../../helpers/axios";
import { mapMutations } from "vuex";

import Niveles from "@/views/Mantenimiento/NivelesyGrados/components/Niveles.vue";
import Grados from "@/views/Mantenimiento/NivelesyGrados/components/Grados.vue";

export default {
  name: "nivelesGradosMant",

  components: {
    niveles: Niveles,
    grados: Grados,
  },

  data: () => ({
    GradosMant: [],
    // tab: 0,
  }),

  mounted() {
    this.getGradosMant();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-- ROBERT.
    //-- METODO CONDICIONADO QUE LISTA TODOS LOS GRADOS SEGUN ID_COLEGIO, DEL AMBITO DE MANTENIMIENTO.
    //-------------obtener grados Mantenimiento
    async getGradosMant() {
      var id = sessionStorage.id_colegio;
      try {
        let response = await axios.get("/mantenimiento/grado/" + id + "");
        this.GradosMant = response.data;
        //console.log(this.GradosMant)
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
  },
};
</script>
